export const categoryOptions = [
  { value: "Kitchen", label: "Kitchen" },
  { value: "Cleaning", label: "Cleaning" },
  { value: "Electronics", label: "Electronics" },
  { value: "Self-care", label: "Self-care" },
  { value: "Clothing", label: "Clothing" },
  { value: "Miscellaneous", label: "Miscellaneous" },
];
